module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xxray flow-page"
  }, [_c('div', {
    staticClass: "flow-title"
  }, [_vm._v("\n        Title\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flow-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flow-col flow-col-main"
  }, [_c('div', {
    staticClass: "flow-panel-outer light-text"
  }, [_c('div', {
    staticClass: "flow-panel"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "border": "solid 3px red"
    }
  }, [_c('YesNo', {
    attrs: {
      "color": "primary",
      "label": "Work Income",
      "question": "Do you receive any income from work?"
    },
    model: {
      value: (_vm.yesorno1),
      callback: function($$v) {
        _vm.yesorno1 = $$v
      },
      expression: "yesorno1"
    }
  }), _vm._v(" "), _c('YesNo', {
    attrs: {
      "color": "primary",
      "label": "Government Income",
      "question": "Do you receive family payments or other government income?"
    },
    model: {
      value: (_vm.yesorno2),
      callback: function($$v) {
        _vm.yesorno2 = $$v
      },
      expression: "yesorno2"
    }
  }), _vm._v(" "), _c('YesNo', {
    attrs: {
      "color": "primary",
      "question": "Do you receive family payments or other government income?"
    },
    model: {
      value: (_vm.yesorno2),
      callback: function($$v) {
        _vm.yesorno2 = $$v
      },
      expression: "yesorno2"
    }
  }), _vm._v(" "), _c('YesNo', {
    attrs: {
      "color": "primary",
      "label": "Government Income"
    },
    model: {
      value: (_vm.yesorno2),
      callback: function($$v) {
        _vm.yesorno2 = $$v
      },
      expression: "yesorno2"
    }
  })], 1), _vm._v(" "), _c('v-switch')], 1)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flow-col flow-col-left"
  }, [_c('span', {
    staticClass: "light-text"
  }, [_vm._v("\n                Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem deserunt dolores magnam, saepe culpa doloribus numquam! Repellendus cumque blanditiis in iste! Commodi non aut aliquid eaque modi nobis iusto! Nihil?\n                Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem deserunt dolores magnam, saepe culpa doloribus numquam! Repellendus cumque blanditiis in iste! Commodi non aut aliquid eaque modi nobis iusto! Nihil?\n                Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem deserunt dolores magnam, saepe culpa doloribus numquam! Repellendus cumque blanditiis in iste! Commodi non aut aliquid eaque modi nobis iusto! Nihil?\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flow-panel-outer light-text"
  }, [_c('div', {
    staticClass: "flow-panel",
    staticStyle: {
      "margin-right": "100px"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "dotted 1px green",
      "display": "flex",
      "min-height": "200px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50px",
      "flex-basis": "50px",
      "text-transform": "uppercase",
      "background-color": "#ddd"
    }
  }, [_c('div', {
    staticStyle: {
      "letter-spacing": "2px",
      "margin-left": "34px",
      "margin-top": "20px",
      "transform": "rotate(90deg)",
      "transform-origin": "0 0"
    }
  }, [_vm._v("\n                                Identification\n                            ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1",
      "position": "relative",
      "background-color": "#eee"
    }
  }, [_c('div', {
    staticClass: "elevation-1",
    staticStyle: {
      "border-radius": "100px",
      "background-color": "white",
      "padding": "10px 20px",
      "position": "relative",
      "left": "30px",
      "margin": "10px"
    }
  }, [_vm._v("\n                                Drivers license and Passport\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "elevation-1",
    staticStyle: {
      "border-radius": "100px",
      "background-color": "white",
      "padding": "10px 20px",
      "position": "relative",
      "left": "30px",
      "margin": "10px"
    }
  }, [_vm._v("\n                                Visa and proof of residency\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "elevation-1",
    staticStyle: {
      "border-radius": "100px",
      "background-color": "white",
      "padding": "10px 20px",
      "position": "relative",
      "left": "30px",
      "margin": "10px"
    }
  }, [_vm._v("\n                                Registration form (attached)\n                            ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flow-col flow-col-right"
  }, [_c('div', {
    staticClass: "flow-panel-outer light-text"
  }, [_c('div', {
    staticClass: "flow-panel"
  }, [_c('object', {
    attrs: {
      "data": "https://firebasestorage.googleapis.com/v0/b/photon-6d209.appspot.com/o/transactions%2F-MGuNNSW9gLeqvrSLh77%2FInsight%20Processing%20Matt%20Ireland%20_%20Brand%20and%20Website%20_%20July%202020%20Adaption%20Grant.pdf?alt=media&token=7bee2859-7646-40b0-b377-c22326e48dfd",
      "type": "application/pdf",
      "width": "500",
      "height": "500"
    }
  }, [_vm._v("\n        alt : "), _c('a', {
    attrs: {
      "href": "https://firebasestorage.googleapis.com/v0/b/photon-6d209.appspot.com/o/transactions%2F-MGuNNSW9gLeqvrSLh77%2FInsight%20Processing%20Matt%20Ireland%20_%20Brand%20and%20Website%20_%20July%202020%20Adaption%20Grant.pdf?alt=media&token=7bee2859-7646-40b0-b377-c22326e48dfd"
    }
  }, [_vm._v("test.pdf")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-566756c1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LayoutPage3.vue
// module id = 2554
// module chunks = 1